/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commander_LiveInputs */

const en_commander_live = /** @type {(inputs: Commander_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commander Live`)
};

const es_commander_live = /** @type {(inputs: Commander_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comandante en Vivo`)
};

const fr_commander_live = /** @type {(inputs: Commander_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commander Live`)
};

const de_commander_live = /** @type {(inputs: Commander_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commander Live`)
};

const ja_commander_live = /** @type {(inputs: Commander_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コマンダー ライブ`)
};

const zh_commander_live = /** @type {(inputs: Commander_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`指挥官在线`)
};

const ar_commander_live = /** @type {(inputs: Commander_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`القائد مباشر`)
};

const id_commander_live = /** @type {(inputs: Commander_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komandan Live`)
};

const it_commander_live = /** @type {(inputs: Commander_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commander in Diretta`)
};

const ru_commander_live = /** @type {(inputs: Commander_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Командный центр (Live)`)
};

const pt_commander_live = /** @type {(inputs: Commander_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commander Live`)
};

const ko_commander_live = /** @type {(inputs: Commander_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`커맨더 라이브`)
};

/**
* | output |
* | --- |
* | "Commander Live" |
*
* @param {Commander_LiveInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const commander_live = /** @type {((inputs?: Commander_LiveInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commander_LiveInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_commander_live(inputs)
	if (locale === "es") return es_commander_live(inputs)
	if (locale === "fr") return fr_commander_live(inputs)
	if (locale === "de") return de_commander_live(inputs)
	if (locale === "ja") return ja_commander_live(inputs)
	if (locale === "zh") return zh_commander_live(inputs)
	if (locale === "ar") return ar_commander_live(inputs)
	if (locale === "id") return id_commander_live(inputs)
	if (locale === "it") return it_commander_live(inputs)
	if (locale === "ru") return ru_commander_live(inputs)
	if (locale === "pt") return pt_commander_live(inputs)
	return ko_commander_live(inputs)
});